import store from '../store'
import _ from 'lodash'
import router from '../router'

const InvalidParamsErrorCode = 3
const AccessDeniedCode = 4
const BusinessLogicErrorCode = 5

function ApiException (code, body, data, userErrorMessage) {
    this.code = code
    this.body = body
    this.data = data
    this.name = 'ApiException'
    this.userErrorMessage = userErrorMessage
}

ApiException.prototype.toString = function () {
    return this.name + ': "' + this.body + '" (' + this.code + ')'
}

export function parseResponse (response) {
    if (!response.data.success) {
        const userId = _.get(store.state, ['user', 'id'], null)
        if (response.data.errorCode === AccessDeniedCode && !userId) {
            router.push("/login")
        }

        let userErrorMessage = null

        if (response.data.errorCode === BusinessLogicErrorCode) {
            userErrorMessage = response.data.error
        }

        throw new ApiException(response.data.errorCode, response.data.error, response.data.data || null, userErrorMessage)
    }

    return response.data.data
}

export function extractValidationErrors (error) {
    const errorCode = _.get(error, 'code', null)

    if (errorCode !== InvalidParamsErrorCode) {
        return null
    }

    return _.get(error, 'body', null)
}

export function extractCommonBackendError (errorResponse, defaultMessage) {
    return _.get(errorResponse, ['body', 'common'], defaultMessage)
}

export function extractUserErrorMessage(error, defaultMessage) {
    const userErrorMessage = _.get(error, 'userErrorMessage')

    if (!userErrorMessage) {
        return defaultMessage
    }

    return userErrorMessage
}
